import { Dimensions } from '@/types'
import { ClusterMetadata, HeaderMetadata } from '.'

const PADDING = 100

export class ClusterAndHeaderBoxMetadata {
  private _cluster: ClusterMetadata
  private _header: HeaderMetadata | undefined
  private _size: Dimensions

  constructor({
    cluster,
    header,
    padding = PADDING,
  }: {
    cluster: ClusterMetadata
    header?: HeaderMetadata
    padding?: number
  }) {
    this._cluster = cluster
    this._header = header

    this._size = {
      width: Math.max(cluster.boundingBoxSize.width, header?.size.width ?? 0) + padding,
      height: cluster.boundingBoxSize.height + (header?.size.height ?? 0) + padding,
    }
  }

  get path() {
    return this._cluster.path
  }

  get area(): number {
    return this._size.width * this._size.height
  }

  get width() {
    return this._size.width
  }

  get height() {
    return this._size.height
  }

  get clusterWidth() {
    return this._cluster.boundingBoxSize.width
  }

  get headerHeight() {
    return this._header?.size.height ?? 0
  }

  getAggregatedFieldValue(field: string) {
    return this._cluster.bubbles.reduce((aggregated, bubble) => {
      const value = parseFloat(bubble.visNode.data[field])
      return aggregated + (isNaN(value) ? 0 : value)
    }, 0)
  }
}
